import React, { Fragment } from 'react';
import ServiciosGestionInversion from '../components/serviciosGestionInversion/serviciosGestionInversion';

const GestionInversionFVG = () => {
  return ( 
    <Fragment>
      <ServiciosGestionInversion />
    </Fragment>
  );
}
 
export default GestionInversionFVG;